import React from 'react';
import {ListItem} from '@mc/ui-v4';
import {ACCESSIBILITY_ITEMS, getAccessibilitySeverityIntent} from '../../assets/accessibility/accessibilityCodelist';
import {ViewportResult} from './searchPanelTypes';

type Props = {
    item: ViewportResult;
    onClick: (item: ViewportResult) => void;
    onMouseEnter: (item: ViewportResult) => void;
    onMouseLeave?: (item: ViewportResult) => void;
};

/**
 * Bohatá položka výřezového seznamu jako ui-v4 ListItem: barevný sideHeader + foto + název + adresa + přístupnost.
 * Zabaleno v {@link React.memo} – při re-renderu panelu (hover, změna filtru…) se nepřekresluje, dokud se
 * nezmění její data ani handlery (ty jsou v SearchPanelu stabilní přes useCallback).
 */
const ViewportResultItemBase: React.FC<Props> = ({item, onClick, onMouseEnter, onMouseLeave}) => {
    // Barevné rozlišení dle přístupnosti: nejzávažnější značka (červená > oranžová > zelená).
    // sideHeader = barevný pruh vlevo přes ListItem.header/headerIntent; objekty bez rozlišovací značky mají pruh bez barvy (jen kvůli zachování stejné šířky).
    const severityIntent = getAccessibilitySeverityIntent(item.accessibilityCodes);
    // Pruh vlevo: barva vrstvy (pokud je), jinak barva dle přístupnosti (severity).
    const showHeader = !!item.layerColor || !!severityIntent;
    return (
        <ListItem
            className={`viewport-result-item${item.layerColor ? ' has-layer-color' : ''}${showHeader ? '' : ' no-header-color'}`}
            style={item.layerColor ? ({'--vp-header-color': item.layerColor} as React.CSSProperties) : undefined}
            onClick={() => onClick(item)}
            // header se vykresluje vždy (i bez barvy) s pevnou headerWidth, aby měly všechny položky stejně širokou levou lištu.
            header={' '}
            // headerIntent={item.layerColor ? undefined : severityIntent}
            headerWidth={9}
        >
            <div className={'viewport-result-body'} onMouseEnter={() => onMouseEnter(item)} onMouseLeave={() => onMouseLeave?.(item)}>
                {/* {item.photoUrl ? (
                    <img className={'result-image result-photo'} src={item.photoUrl} alt={''} loading={'lazy'} />
                ) : item.layerImageUrl ? (
                    <img className={'result-image layer-icon'} src={item.layerImageUrl} alt={''} loading={'lazy'} />
                ) : (
                    <div className={'result-image-placeholder'} />
                )} */}
                <div className={'result-content'}>
                    <div className={'result-label'}>{item.label}</div>
                    {item.subtitle && <div className={'result-suffix'}>{item.subtitle}</div>}
                    {item.accessibilityCodes.length > 0 && (
                        <div className={'result-accessibility'}>
                            {/* Vykreslíme VŠECHNY ikony přístupnosti; ty, které objekt nemá, zobrazíme zašedle (neaktivní),
                                shodně s detailem objektu (renderAccessibilityIcons). */}
                            {ACCESSIBILITY_ITEMS.map(a => {
                                const inactive = !item.accessibilityCodes.includes(a.kod);
                                return (
                                    <img
                                        key={a.kod}
                                        className={`result-accessibility-icon${inactive ? ' result-accessibility-icon--inactive' : ''}`}
                                        src={a.icon}
                                        alt={a.nazev}
                                        title={a.nazev}
                                    />
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </ListItem>
    );
};

export const ViewportResultItem = React.memo(ViewportResultItemBase);
